import { render, staticRenderFns } from "./KorrespondenzVorlageStammdaten.vue?vue&type=template&id=705afa14"
import script from "./KorrespondenzVorlageStammdaten.vue?vue&type=script&lang=js"
export * from "./KorrespondenzVorlageStammdaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports